import React from 'react';
import './App.css';
import ImageWithFallback from "./ImageWithFallback";

const EvenOrOdd = () => {
  return (
    <div className="page-container">
      <div className="hero-section">
        <h1>Even or Odd</h1>
        <p>Determine whether a number is even or odd with this simple Python script.</p>
        <ImageWithFallback src="/Even_or_Odd.png" alt="Even or Odd" className="hero-image" />
      </div>
      <div className="content-section">
        <h2>Project Description</h2>
        <p>This project helps you identify whether a given number is even or odd using Python.</p>
        <h2>Download</h2>
        <a href="/Even_or_Odd.py" download>Download Even_or_Odd.py</a>
        <h2>How to Run</h2>
        <p>Run the Python file and input a number to check if it's even or odd.</p>
      </div>
    </div>
  );
};

export default EvenOrOdd;
